@if (loading()) {
<app-loading></app-loading>
} @else if (!loading() && data && !offer) {
<app-not-found></app-not-found>
} @else {
<ng-container *transloco="let t">
  <div class="container no-container-on-mobile">
    @if (offer.images && offer.images.length <= 1) {
    <div class="mb-3 header-bg-img cover-image" [ngStyle]="{ 'background-image': 'url(' + (offer.images?.[0]?.path || offer.foto) + ')' }"></div>
    } @else {
      <p-galleria class="offer-galleria" containerClass="border-none" [value]="offer.images" [autoPlay]="true" [circular]="true"
        [showItemNavigators]="true" [showIndicators]="true" [showThumbnails]="false" [activeIndex]="galleryActiveIndex"
        (activeIndexChange)="galleryActiveIndex = $event">
        <ng-template #item let-item>
          <div class="offer-galleria-item">
            <img [src]="item.path" />
            <span class="offer-galleria-counter">{{ galleryActiveIndex + 1 }}/{{ offer.images.length }}</span>
          </div>
        </ng-template>
      </p-galleria>
    }
  </div>

  <div class="container">
    <!-- Page header -->
    @if (offer.tags && offer.tags[currentLang]) {
    <div class="mb-2 w-full flex justify-content-end">
      @for (tag of offer.tags[currentLang].split(','); track tag) {
      <p-chip [style]="{'font-size': '.75rem'}" class="ml-2s text-xs p-chip-info cursor-pointer"
        [label]="tag.trim()" [tabindex]="0" (click)="goToOffersByTag(tag)"
        (keyup.enter)="goToOffersByTag(tag)" [attr.aria-label]="'Filtra per tag ' + tag.trim()"></p-chip>
      }
    </div>
    }
    <h1 class="mb-2">{{ offer.titolo | translate }}</h1>

    @if (offer.scadenza) {
    <div class="flex align-items-center">
      <span class="material-icons text-indigo-500" aria-hidden="true">
        event
      </span>
      <span [countdown]="offer.scadenza" class="ml-2"></span>
    </div>
    }

    @if (offer.prezzo) {
    <div class="flex align-items-center mt-2">
      <span class="material-icons text-indigo-500" aria-hidden="true">
        sell
      </span>
      <span class="ml-2">{{t('price')}}
        <span [ngClass]="{'line-through': offer.prezzo_scontato}">€{{
          formatPrice(offer.prezzo)
          }}</span>
        @if (offer.prezzo_scontato) {
        <span class="ml-1 font-semibold">€{{
          formatPrice(offer.prezzo_scontato)
          }}</span>
        }
      </span>
    </div>
    }

    @if (data.locations.length > 0 && offer.location_id && !offer.indirizzo) {
    <div class="flex align-items-center mt-2">
      <span class="material-icons text-indigo-500" aria-hidden="true">
        place
      </span>
      <span class="ml-2">{{ offer.location_id == 1 ? t('main_location') : t('location') + ' ' +
        getLocationTitle(offer.location_id) }}</span>
    </div>
    }

    @if (offer.indirizzo) {
    <div class="flex align-items-center mt-2">
      <span class="material-icons text-indigo-500" aria-hidden="true">
        map
      </span>
      <span class="ml-2">{{ offer.indirizzo }}</span>
    </div>
  }

  @if (offer.data && !(offer.tipologia == 'product' || offer.tipologia == 'service')) {
    <div class="flex align-items-center mt-2">
      <span class="material-icons text-indigo-500" aria-hidden="true">
        calendar_month
      </span>
      <span class="ml-2">{{ offer.data }}</span>
    </div>
  }

    @if (offer.orario && !(offer.tipologia == 'product' || offer.tipologia == 'service')) {
    <div class="flex align-items-center mt-2">
      <span class="material-icons text-indigo-500" aria-hidden="true" role="separator">
        schedule
      </span>
      <span class="ml-2">{{ offer.orario }}</span>
    </div>
  }

    <div [innerHTML]="offer.descrizione | translate"></div>

    <!-- Files section -->
    @let filesForLang = offer.attachments && offer.attachments[currentLang] ? offer.attachments[currentLang] : null;
    @if (filesForLang && filesForLang.length > 0) {
    <div class="mt-4">
      <h2 class="mb-2">{{ t('attachments') }}</h2>
      <ul class="list-none p-0">
        @for (file of filesForLang; track file.path) {
        <a [href]="file.path" target="_blank" class="no-underline text-900" [attr.aria-label]="'Scarica ' + file.nome">
          <li class="mb-3 flex align-items-center border-1 border-gray-300 border-round p-2">
            <img [src]="getFileImage(file.extension)" (error)="$event.target.src='/files/file.png'" alt="" class="mr-2" style="width: 32px; height: 32px;">
            <span class="ml-2 flex-grow-1 font-semibold">{{ file.original_name }}</span>
            <span class="material-icons text-green-600" aria-hidden="true">download</span>
          </li>
        </a>
        }
      </ul>
    </div>
    }

    <ul class="list-none p-0 contact-buttons flex flex-wrap mt-4 justify-content-around align-items-start">
      <li>
        <a (click)="insightService.send({event: 'click', event_name: 'click_phone'})" href="tel:{{ data.telephone }}"
          target="_blank" aria-label="Chiamaci"
          class="mt-2 ml-2 text-white border-round font-semibold shadow-4 pt-3 pb-3 pl-4 pr-4 bg-green-600 flex align-items-center no-underline p-button-link justify-content-center">
          <span class="material-icons" aria-hidden="true">
            call
          </span>
          <span class="ml-2 uppercase">{{t('cta.call')}}</span>
        </a>
      </li>
      @if (data.telegram) {
      <li>
        <a (click)="insightService.send({event: 'click', event_name: 'chat_telegram'})" target="_blank"
          [href]="'https://t.me/' + data.telegram.split('@').join('')"
          class="mt-2 ml-2 border-green-600 text-green-600 border-1 border-round font-semibold shadow-4 pt-3 pb-3 pl-4 pr-4 flex align-items-center no-underline p-button-link justify-content-center"
          aria-label="Chatta su Telegram">
          <span class="material-icons" aria-hidden="true">
            chat_bubble
          </span>
          <span class="ml-2 uppercase">{{t('cta.telegram')}}</span>
        </a>
      </li>
    }
      @if (data.whatsapp) {
      <li>
        <a (click)="insightService.send({event: 'click', event_name: 'chat_whatsapp'})" target="_blank"
          [href]="'https://wa.me/' + data.whatsapp"
          class="mt-2 ml-2 border-green-600 text-green-600 border-1 border-round font-semibold shadow-4 pt-3 pb-3 pl-4 pr-4 flex align-items-center no-underline p-button-link justify-content-center"
          aria-label="Chatta su Whatsapp">
          <span class="material-icons" aria-hidden="true">
            question_answer
          </span>
          <span class="ml-2 uppercase">{{t('cta.whatsapp')}}</span>
        </a>
      </li>
    }
    </ul>

    <!-- Share -->
    <div class="mb-0 text-center mt-6">
      <p class="mb-0 mt-0">{{ t('share_offer') }}</p>
      <ul class="list-none p-0 social-buttons flex flex-wrap text-center justify-content-center">
        <!-- <li>
          <a class="mt-3 share-button facebook no-underline" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'share'})"
            href="https://www.facebook.com/sharer/sharer.php?u={{ generateShareOfferUrl(offer) }}"
            title="Condividi su facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path fill="#ffffff"
                d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
            </svg>
          </a>
        </li>
        <li> <a class="mt-3 share-button twitter no-underline" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'share'})"
            href="https://twitter.com/share?text={{ generateShareOfferUrl(offer) }}" title="Condividi su X">
            <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision"
              text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd"
              clip-rule="evenodd" viewBox="0 0 512 462.799">
              <path fill="#fff" fill-rule="nonzero"
                d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z" />
            </svg>
          </a>
        </li> -->
        <li> <a class="mt-3 share-button whatsapp no-underline" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'share'})"
            href="whatsapp://send?text={{ generateShareOfferUrl(offer) }}" title="Condividi su whatsapp">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="#ffffff"
                d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
            </svg>
          </a>
        </li>
        <!-- <li> <a class="mt-3 share-button telegram no-underline" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'share'})"
            href="https://t.me/share/url?url={{ rawurlencode(generateShareOfferUrl(offer))  }}&text={{ rawurlencode(offer.titolo) }}"
            title="Condividi su telegram">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
              <path fill="#ffffff"
                d="M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM363 176.7c-3.7 39.2-19.9 134.4-28.1 178.3-3.5 18.6-10.3 24.8-16.9 25.4-14.4 1.3-25.3-9.5-39.3-18.7-21.8-14.3-34.2-23.2-55.3-37.2-24.5-16.1-8.6-25 5.3-39.5 3.7-3.8 67.1-61.5 68.3-66.7 .2-.7 .3-3.1-1.2-4.4s-3.6-.8-5.1-.5q-3.3 .7-104.6 69.1-14.8 10.2-26.9 9.9c-8.9-.2-25.9-5-38.6-9.1-15.5-5-27.9-7.7-26.8-16.3q.8-6.7 18.5-13.7 108.4-47.2 144.6-62.3c68.9-28.6 83.2-33.6 92.5-33.8 2.1 0 6.6 .5 9.6 2.9a10.5 10.5 0 0 1 3.5 6.7A43.8 43.8 0 0 1 363 176.7z" />
            </svg>
          </a>
        </li> -->
        <li> <a class="mt-3 share-button email no-underline" target="_blank"
            (click)="insightService.send({event: 'click', event_name: 'share'})"
            href="mailto:?body={{ generateShareOfferUrl(offer) }}" title="Condividi per email">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="#ffffff"
                d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
            </svg>
          </a>
        </li>
        @if( canBrowserShareData()) {
        <li>
          <a (click)="share()" class="mt-3 share-button share no-underline">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
              <path
                d="M11 6C12.6569 6 14 4.65685 14 3C14 1.34315 12.6569 0 11 0C9.34315 0 8 1.34315 8 3C8 3.22371 8.02449 3.44169 8.07092 3.65143L4.86861 5.65287C4.35599 5.24423 3.70652 5 3 5C1.34315 5 0 6.34315 0 8C0 9.65685 1.34315 11 3 11C3.70652 11 4.35599 10.7558 4.86861 10.3471L8.07092 12.3486C8.02449 12.5583 8 12.7763 8 13C8 14.6569 9.34315 16 11 16C12.6569 16 14 14.6569 14 13C14 11.3431 12.6569 10 11 10C10.2935 10 9.644 10.2442 9.13139 10.6529L5.92908 8.65143C5.97551 8.44169 6 8.22371 6 8C6 7.77629 5.97551 7.55831 5.92908 7.34857L9.13139 5.34713C9.644 5.75577 10.2935 6 11 6Z"
                fill="#ffffff" />
            </svg>
          </a>
        </li>
        }
      </ul>
    </div>

    <div class="text-center mt-6">
      <p-button (onClick)="router.navigate(['/proposte'])">{{ t('all_offers') | uppercase }}</p-button>
    </div>
  </div>
</ng-container>
}